// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import breakpointValues, { BreakpointValue } from "@store/Framework/Common/Utilities/breakpointValues";
import { pxToRem, pxToRemArray } from "@store/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

export const boxStyles = (padding: BreakpointValue[] | null = pxToRemArray([25, 32, 40])) => css`
    border-radius: ${x => x.theme.design.common.contentRadius};
    box-shadow: ${x => x.theme.shadows.e60};
    background-color: ${getColor("common.background")};
    ${padding ? breakpointValues(padding, "padding") : null}
`;

export const boxStickyStyles = () => css`
    padding: ${pxToRem(10)};
    box-shadow: ${props => props.theme.shadows.e60Up};
    background-color: ${getColor("common.background")};
`;
